import { createEvent, createStore, restore, sample } from 'effector'
import { fx } from 'src/libs'
import {
  NotificationPayload,
  showNotification,
} from 'src/pages/goldenMay2026/model'
import { AddTicketsRequest, Ticket, TicketsResponse } from './types'

export const ticketsListLoad = createEvent()
export const changeStatusSubmit = createEvent<{
  userID: number
}>()

export const getTicketsFx = fx<void | any, TicketsResponse>({
  method: 'GET',
  url: `/promo/golden_may_2026/tickets/issue`,
})

export const changeStatusFx = fx<any, void>({
  method: 'POST',
  url: `/promo/golden_may_2026/tickets/issue`,
})

export const addTicketsFx = fx<AddTicketsRequest, void>({
  method: 'POST',
  url: `/promo/golden_may_2026/tickets/reserve`,
})

export const $tickets = createStore<Ticket[]>([]).on(
  getTicketsFx.doneData,
  (_, res) => res.body.items,
)

export const $totalCountOfTickets = restore(
  getTicketsFx.doneData.map((a) => a.body.total),
  0,
)

sample({
  clock: [ticketsListLoad, changeStatusFx.doneData],
  fn: () => ({}),
  target: getTicketsFx,
})

sample({
  clock: changeStatusSubmit,
  fn: ({ userID }) => ({
    url: `/promo/golden_may_2026/tickets/issue`,
    body: { userID },
  }),
  target: changeStatusFx,
})

sample({
  clock: [
    getTicketsFx.failData,
    changeStatusFx.failData,
    addTicketsFx.failData,
  ],
  fn: (error): NotificationPayload => ({
    type: 'error',
    message: 'Request failed',
    description: error?.body?.message ?? 'Request failed',
  }),
  target: showNotification,
})

sample({
  clock: changeStatusFx.doneData,
  fn: (): NotificationPayload => ({
    type: 'success',
    message: 'Success',
    description: 'Ticket successfully issued',
  }),
  target: showNotification,
})

sample({
  clock: addTicketsFx.doneData,
  fn: (): NotificationPayload => ({
    type: 'success',
    message: 'Success',
    description: 'Ticket added successfully',
  }),
  target: showNotification,
})
